export default "__VITE_ASSET__CaBPpdma__"